<template>
  <div class="custom-wrapper">
    <!-- Sidebar con overlay para móviles -->
    <div class="mobile-sidebar-overlay"
         v-if="isMobile"
         :class="{ 'active': sidebarVisible }"
         @click="toggleSidebar"></div>
    <!-- Sidebar -->
    <div class="custom-sidebar" :class="{
      'collapsed': !sidebarVisible,
      'mobile-view': isMobile
    }">
      <div class="logo">
        <a href="#" class="logo-link">
          <div class="logo-image">
            <img src="/img/logo-sia2.png" alt="Logo">
          </div>
        </a>
      </div>
      <div class="sidebar-nav">
        <ul class="nav-list">
          <li :class="{ active: $route.name === 'dashboard' }">
            <router-link to="/" class="nav-item">
              <i class="fas fa-home"></i>
              <span>Inicio</span>
            </router-link>
          </li>

          <li v-if="hasPermission('user_read')" :class="{ active: $route.path.includes('/users') }">
            <router-link to="/users" class="nav-item">
              <i class="fas fa-user"></i>
              <span>Usuarios</span>
            </router-link>
          </li>

          <li v-if="hasPermission('role_read')" :class="{ active: $route.path.includes('/roles') }">
            <router-link to="/roles" class="nav-item">
              <i class="fas fa-key"></i>
              <span>Roles</span>
            </router-link>
          </li>
          <li v-if="hasPermission('unidad_read')" :class="{ active: $route.path.includes('/unidad') }">
            <router-link to="/unidad" class="nav-item">
              <i class="fas fa-university"></i>
              <span>Unidades</span>
            </router-link>
          </li>

          <li v-if="hasPermission('area_read')" :class="{ active: $route.path.includes('/area') }">
            <router-link to="/area" class="nav-item">
              <i class="fas fa-building"></i>
              <span>Secciones</span>
            </router-link>
          </li>

          <li v-if="hasPermission('valorado_read')" :class="{ active: $route.path.includes('/valorado') }">
            <router-link to="/valorado" class="nav-item">
              <i class="fas fa-certificate"></i>
              <span>Valorados</span>
            </router-link>
          </li>
          <li v-if="hasPermission('tipotramite_read')" :class="{ active: $route.path.includes('/tipotramite') }">
            <router-link to="/tipotramite" class="nav-item">
              <i class="fas fa-list"></i>
              <span>Tipo Tramite</span>
            </router-link>
          </li>
          <li v-if="hasPermission('persona_read')" :class="{ active: $route.path.includes('/persona') }">
            <router-link to="/persona" class="nav-item">
              <i class="fas fa-users"></i>
              <span>Personas</span>
            </router-link>
          </li>
          <li v-if="hasPermission('ventanilla_read')" :class="{ active: $route.path.includes('/tramite') }">
            <router-link to="/tramite" class="nav-item">
              <i class="fas fa-file"></i>
              <span>Recibir Tramite</span>
            </router-link>
          </li>
          <li v-if="hasPermission('evaluacion_read')" :class="{ active: $route.path.includes('/tramite/proceso') }">
            <router-link to="/tramite/proceso" class="nav-item">
              <i class="fas fa-file"></i>
              <span>Procesar Tramite</span>
            </router-link>
          </li>
          <li v-if="hasPermission('aprobacion_read')" :class="{ active: $route.path.includes('/tramite/proceso') }">
            <router-link to="/tramite/proceso" class="nav-item">
              <i class="fas fa-file"></i>
              <span>Aprobar Tramite</span>
            </router-link>
          </li>
          <li v-if="hasPermission('entrega_read')" :class="{ active: $route.path.includes('/tramiteEntrega') }">
            <router-link to="/tramiteEntrega" class="nav-item">
              <i class="fas fa-file"></i>
              <span>Aprobar Entrega</span>
            </router-link>
          </li>
          <li v-if="hasPermission('informe_read')" :class="{ active: $route.path.includes('/informe') }">
            <router-link to="/informe" class="nav-item">
              <i class="fas fa-certificate"></i>
              <span>Informes</span>
            </router-link>
          </li>
          <li v-if="hasPermission('tramite_read')" :class="{ active: $route.path.includes('/reporteEconomico') }">
            <router-link to="/reporteEconomico" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Economico</span>
            </router-link>
          </li>
          <li v-if="hasPermission('ventanilla_read')" :class="{ active: $route.path.includes('/reporteEco') }">
            <router-link to="/reporteEco" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Eco Nuevo</span>
            </router-link>
          </li>
          <li v-if="hasPermission('tramite_read')" :class="{ active: $route.path.includes('/reporteValores') }">
            <router-link to="/reporteValorados" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Valores</span>
            </router-link>
          </li>
          <li v-if="hasPermission('entrada_read')" :class="{ active: $route.path.includes('/tramites/reporteestado') }">
            <router-link to="/tramites/reporteestado" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Tramites</span>
            </router-link>
          </li>
          <li v-if="hasPermission('tramite_read')" :class="{ active: $route.path.includes('/reporte-almacen') }">
            <router-link to="/reporte-almacen" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Almacen</span>
            </router-link>
          </li>
          <hr>
          <li v-if="hasPermission('compra_read')" :class="{ active: $route.path.includes('/categorias') }">
            <router-link to="/categorias" class="nav-item">
              <i class="fas fa-sitemap"></i>
              <span>Categorias</span>
            </router-link>
          </li>
          <li v-if="hasPermission('compra_read')" :class="{ active: $route.path.includes('/items') }">
            <router-link to="/items" class="nav-item">
              <i class="fas fa-clipboard-list"></i>
              <span>Items</span>
            </router-link>
          </li>
          <li v-if="hasPermission('compra_read')" :class="{ active: $route.path.includes('/partidas') }">
            <router-link to="/partidas" class="nav-item">
              <i class="fas fa-table"></i>
              <span>Partidas</span>
            </router-link>
          </li>
          <li v-if="hasPermission('compra_read')" :class="{ active: $route.path.includes('/proveedores') }">
            <router-link to="/proveedores" class="nav-item">
              <i class="fas fa-truck"></i>
              <span>Proveedores</span>
            </router-link>
          </li>
          <li v-if="hasPermission('compra_read')" :class="{ active: $route.path.includes('/compras') }">
            <router-link to="/compras" class="nav-item">
              <i class="fas fa-shopping-cart"></i>
              <span>Almacen Compras</span>
            </router-link>
          </li>
          <li v-if="hasPermission('entrada_read')" :class="{ active: $route.path.includes('/entradas') }">
            <router-link to="/entradas" class="nav-item">
              <i class="fas fa-list-alt"></i>
              <span>Almacen Entradas</span>
            </router-link>
          </li>
          <li v-if="hasPermission('salida_read')" :class="{ active: $route.path.includes('/salidas') }">
            <router-link to="/salidas" class="nav-item">
              <i class="fas fa-box-open"></i>
              <span>Almacen Salidas</span>
            </router-link>
          </li>
          <li v-if="hasPermission('almventanilla_read')" :class="{ active: $route.path.includes('/ventanilla') }">
            <router-link to="/ventanilla" class="nav-item">
              <i class="fas fa-box-open"></i>
              <span>Almacen Ventanilla</span>
            </router-link>
          </li>
          <li v-if="hasPermission('almventanilla_read')" :class="{ active: $route.path.includes('/ventanillaReporte') }">
            <router-link to="/ventanillaReporte" class="nav-item">
              <i class="fas fa-box-open"></i>
              <span>Rep.Almacen Ventanilla</span>
            </router-link>
          </li>
          <li v-if="hasPermission('entrada_read')" :class="{ active: $route.path.includes('/reporte-stock') }">
            <router-link to="/reporte-stock" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Stock</span>
            </router-link>
          </li>
          <!--
          <li :class="{ active: $route.path.includes('/reporte-kardex') }">
            <router-link to="/reporte-kardex" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Reporte Kardex</span>
            </router-link>
          </li>

          -->

          <li v-if="hasPermission('entrada_read')" :class="{ active: $route.path.includes('/resumenalmacen') }">
            <router-link to="/resumenalmacen" class="nav-item">
              <i class="fas fa-file-pdf"></i>
              <span>Resumen Almacen</span>
            </router-link>
          </li>
          <hr>
          <li v-if="hasPermission('solicitud_view')" :class="{ active: $route.path.includes('/contratacion/parametros') }">
            <router-link to="/contratacion/parametros" class="nav-item">
              <i class="fas fa-sitemap"></i>
              <span>Parametros Poa</span>
            </router-link>
          </li>
          <li v-if="hasPermission('solicitud_view')" :class="{ active: $route.path.includes('/contratacion/recursos') }">
            <router-link to="/contratacion/recursos" class="nav-item">
              <i class="fas fa-sitemap"></i>
              <span>Recursos</span>
            </router-link>
          </li>
          <li v-if="hasPermission('solicitud_view')" :class="{ active: $route.path.includes('/contratacion/solicitudes') }">
            <router-link to="/contratacion/solicitudes" class="nav-item">
              <i class="fas fa-sitemap"></i>
              <span>Contrataciones</span>
            </router-link>
          </li>
          <li v-if="hasPermission('solicitud_view')" :class="{ active: $route.path.includes('/ticket/reporte') }">
            <router-link to="/ticket/reporte" class="nav-item">
              <i class="fas fa-sitemap"></i>
              <span>Reporte Tickets</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- Main Panel -->
    <div class="main-panel" :class="{ 'expanded': !sidebarVisible }">
      <!-- Navbar -->
      <nav class="custom-navbar">
        <div class="navbar-content">
          <button class="sidebar-toggle" @click="toggleSidebar">
            <span class="toggle-bar"></span>
            <span class="toggle-bar"></span>
            <span class="toggle-bar"></span>
          </button>

          <div class="page-title d-none d-md-block">DDE-Beni</div>
          <div class="page-title-mobile d-block d-md-none">DDE-Beni</div>

          <!-- ===== CONTROLES DE VENTANILLA - SOLO PARA ROLES PERMITIDOS ===== -->
          <div class="ventanilla-controls"
               v-if="ventanillaInfo && tieneAccesoVentanilla">
            <div class="ventanilla-info">
              <span class="ventanilla-badge">
                Ventanilla: <strong>{{ ventanillaInfo.codigo }}</strong>
              </span>
              <span class="ventanilla-estado" :class="ventanillaInfo.estado">
                {{ getEstadoTexto(ventanillaInfo.estado) }}
              </span>
            </div>

            <div class="ventanilla-actions">
              <!-- Si hay ticket en atención -->
              <div v-if="ticketActual" class="atencion-activa">
                <span class="ticket-actual-label">Atendiendo:</span>
                <span class="ticket-actual-numero">{{ ticketActual.numero_ticket }}</span>
                <span class="tiempo-atencion-dash">
                  ⏱️ {{ tiempoAtencionFormateado }}
                </span>
                <button
                  @click="finalizarAtencion"
                  class="btn-finalizar-dash"
                  :disabled="finalizando"
                >
                  Finalizar
                </button>
              </div>

              <!-- Botón llamar siguiente -->
              <div v-else>
                <button
                  @click="llamarSiguiente"
                  class="btn-llamar-dash"
                  :disabled="llamando || ticketsEspera === 0"
                >
                  <span class="btn-icon-dash">🔔</span>
                  Llamar Siguiente
                  <span v-if="ticketsEspera > 0" class="btn-count-dash">
                    {{ ticketsEspera }}
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div class="user-menu">
            <div class="user-dropdown" @click="toggleUserDropdown">
              <i class="nc-icon nc-single-02"></i>
              <div class="user-info d-none d-md-flex">
                <span class="user-name">{{ userName }} {{ userLastName }}</span>
                <span class="user-roles">{{ userRoles }}</span>
              </div>
              <div class="dropdown-content" :class="{ 'show': showUserDropdown }">
                <a href="#" @click.prevent="openChangePasswordModal">Cambiar contraseña</a>
                <a href="#" @click.prevent="logout">Cerrar sesión</a>
              </div>
            </div>
          </div>
        </div>
      </nav>

      <!-- Content -->
      <div class="content-wrapper">
        <router-view></router-view>
      </div>

      <!-- Footer -->
      <footer class="custom-footer">
        <div class="footer-content">
          &copy; {{ new Date().getFullYear() }} Sistema de Tramites - DDE-Beni
        </div>
      </footer>
    </div>
    <!-- Modal para cambiar contraseña -->
    <div v-if="showPasswordModal" class="modal-overlay" @click.self="closePasswordModal">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Cambiar contraseña</h3>
          <button class="modal-close" @click="closePasswordModal">&times;</button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="changePassword">
            <div class="form-group">
              <label for="currentPassword">Contraseña actual:</label>
              <input
                type="password"
                id="currentPassword"
                v-model="passwordForm.currentPassword"
                required
                autocomplete="off"
                class="form-control"
              >
            </div>
            <div class="form-group">
              <label for="newPassword">Nueva contraseña:</label>
              <input
                type="password"
                id="newPassword"
                v-model="passwordForm.newPassword"
                required
                autocomplete="off"
                minlength="8"
                class="form-control"
              >
            </div>
            <div class="form-group">
              <label for="confirmPassword">Confirmar nueva contraseña:</label>
              <input
                type="password"
                id="confirmPassword"
                v-model="passwordForm.confirmPassword"
                required
                autocomplete="off"
                class="form-control"
              >
            </div>
            <div v-if="passwordError" class="error-message">
              {{ passwordError }}
            </div>
            <div class="modal-actions">
              <button type="button" @click="closePasswordModal" class="btn btn-secondary">
                Cancelar
              </button>
              <button type="submit" :disabled="isChangingPassword" class="btn btn-primary">
                {{ isChangingPassword ? 'Cambiando...' : 'Cambiar contraseña' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted, ref, reactive, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../stores/authStore';
import axios from 'axios';

export default {
  setup() {
    const authStore = useAuthStore();
    const route = useRoute();
    const showUserDropdown = ref(false);
    const isMobile = ref(false);
    const sidebarVisible = ref(true);
    const showPasswordModal = ref(false);
    const isChangingPassword = ref(false);
    const passwordError = ref('');

    // ===== VARIABLES DE VENTANILLA =====
    const ventanillaInfo = ref(null);
    const ticketActual = ref(null);
    const ticketsEspera = ref(0);
    const ultimoLlamado = ref(null);
    const llamando = ref(false);
    const finalizando = ref(false);
    const tiempoAtencion = ref(0);
    let timerInterval = null;
    let refreshInterval = null;

    // ===== COMPUTADOS DE PERMISOS =====
    const tieneAccesoVentanilla = computed(() => {
      // Solo mostrar si tiene permisos de ventanilla o entrega
      return authStore.hasPermission('ventanilla_read') ||
             authStore.hasPermission('entrega_read') ||
             authStore.hasPermission('evaluacion_read') ||
             authStore.hasPermission('aprobacion_read');
    });

    const passwordForm = reactive({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });

    // Detectar si es móvil
    const checkIfMobile = () => {
      isMobile.value = window.innerWidth < 768;
      if (isMobile.value) {
        sidebarVisible.value = false;
      } else {
        sidebarVisible.value = true;
      }
    };

    const tiempoAtencionFormateado = computed(() => {
      const minutos = Math.floor(tiempoAtencion.value / 60);
      const segundos = tiempoAtencion.value % 60;
      return `${minutos.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
    });

    // ===== FUNCIONES DE VENTANILLA =====
    const getEstadoTexto = (estado) => {
      const estados = {
        'disponible': '🟢 Disponible',
        'ocupada': '🔴 Ocupada',
        'pausa': '🟡 En pausa',
        'mantenimiento': '⚙️ Mantenimiento'
      };
      return estados[estado] || estado;
    };

    const cargarEstadoVentanilla = async () => {
      // Verificar permisos antes de cargar
      if (!tieneAccesoVentanilla.value) {
        return;
      }

      try {
        const response = await axios.get('/ventanilla/estado');

        if (response.data.success) {
          const data = response.data.data;
          ventanillaInfo.value = data.ventanilla;
          ticketActual.value = data.ticket_actual;
          ticketsEspera.value = data.tickets_espera;
          ultimoLlamado.value = data.ultimo_llamado;

          // Iniciar timer si hay atención activa
          if (ticketActual.value && ticketActual.value.inicio_atencion) {
            const inicio = new Date(ticketActual.value.inicio_atencion);
            const ahora = new Date();
            tiempoAtencion.value = Math.floor((ahora - inicio) / 1000);

            if (timerInterval) clearInterval(timerInterval);
            timerInterval = setInterval(() => {
              tiempoAtencion.value++;
            }, 1000);
          } else {
            if (timerInterval) clearInterval(timerInterval);
            tiempoAtencion.value = 0;
          }
        }
      } catch (error) {
        console.error('Error al cargar estado de ventanilla:', error);
        // No mostrar alert para evitar errores en usuarios sin permisos
      }
    };

    const llamarSiguiente = async () => {
      // Verificar permisos
      if (!tieneAccesoVentanilla.value) {
        return;
      }

      if (llamando.value || ticketsEspera.value === 0) return;

      llamando.value = true;
      try {
        const response = await axios.post('/ventanilla/llamar-siguiente');

        if (response.data.success) {
          await cargarEstadoVentanilla();
          // Reproducir sonido
          const audio = new Audio('/sounds/campana.mp3');
          audio.play().catch(e => console.log('Audio no disponible'));
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        alert(error.response?.data?.message || 'Error al llamar ticket');
      } finally {
        llamando.value = false;
      }
    };

    const finalizarAtencion = async () => {
      // Verificar permisos
      if (!tieneAccesoVentanilla.value) {
        return;
      }

      if (!ticketActual.value || finalizando.value) return;

      finalizando.value = true;
      try {
        const response = await axios.post(`/ventanilla/finalizar-atencion/${ticketActual.value.id}`);

        if (response.data.success) {
          if (timerInterval) clearInterval(timerInterval);
          tiempoAtencion.value = 0;
          await cargarEstadoVentanilla();
          alert('Atención finalizada exitosamente');
        } else {
          alert(response.data.message);
        }
      } catch (error) {
        alert(error.response?.data?.message || 'Error al finalizar atención');
      } finally {
        finalizando.value = false;
      }
    };

    const userName = computed(() => {
      return authStore.user?.user?.nombres || 'Usuario';
    });
    const userLastName = computed(() => {
      return authStore.user?.user?.paterno || '';
    });
    const unidad = computed(() => {
      return authStore.user?.user?.unidad || '';
    });

    const userRoles = computed(() => {
      const roles = authStore.user?.roles || [];
      return roles.join(', ');
    });

    const pageTitle = computed(() => {
      switch (route.name) {
        case 'dashboard': return 'Dashboard';
        case 'users': return 'Gestión de Usuarios';
        case 'users.create': return 'Crear Usuario';
        case 'users.edit': return 'Editar Usuario';
        case 'roles': return 'Gestión de Roles';
        case 'roles.create': return 'Crear Rol';
        case 'roles.edit': return 'Editar Rol';
        case 'unidad': return 'Gestión de Unidades Organizacionales';
        default: return 'Sistema de Tramites DDE-Beni';
      }
    });

    const hasPermission = (permission) => {
      return authStore.hasPermission(permission);
    };

    const toggleSidebar = () => {
      if (isMobile.value) {
        sidebarVisible.value = !sidebarVisible.value;
      } else {
        sidebarVisible.value = !sidebarVisible.value;
      }
    };

    const toggleUserDropdown = () => {
      showUserDropdown.value = !showUserDropdown.value;
    };

    const openChangePasswordModal = () => {
      showPasswordModal.value = true;
      showUserDropdown.value = false;
      passwordForm.currentPassword = '';
      passwordForm.newPassword = '';
      passwordForm.confirmPassword = '';
      passwordError.value = '';
    };

    const closePasswordModal = () => {
      showPasswordModal.value = false;
      showUserDropdown.value = false;
    };

    const changePassword = async () => {
      if (passwordForm.newPassword !== passwordForm.confirmPassword) {
        passwordError.value = 'Las contraseñas no coinciden';
        return;
      }

      if (passwordForm.newPassword.length < 8) {
        passwordError.value = 'La nueva contraseña debe tener al menos 8 caracteres';
        return;
      }

      isChangingPassword.value = true;
      passwordError.value = '';

      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

        const response = await fetch('/api/change-password', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authStore.token}`,
            'X-CSRF-TOKEN': csrfToken || '',
            'Accept': 'application/json'
          },
          credentials: 'include',
          body: JSON.stringify({
            current_password: passwordForm.currentPassword,
            new_password: passwordForm.newPassword,
            new_password_confirmation: passwordForm.confirmPassword
          })
        });

        const data = await response.json();

        if (response.ok) {
          alert('Contraseña cambiada exitosamente');
          closePasswordModal();
        } else {
          passwordError.value = data.message || 'Error al cambiar la contraseña';
        }
      } catch (error) {
        passwordError.value = 'Error de conexión';
      } finally {
        isChangingPassword.value = false;
      }
    };

    const logout = async () => {
      await authStore.logout();
    };

    // ===== CICLO DE VIDA =====
    onMounted(() => {
      checkIfMobile();
      window.addEventListener('resize', checkIfMobile);
      if (!authStore.user) {
        authStore.fetchUser();
      }

      // Solo cargar estado de ventanilla si tiene permisos

      if (tieneAccesoVentanilla.value) {
        cargarEstadoVentanilla();

        // Auto-refresh cada 10 segundos
        refreshInterval = setInterval(() => {
          if (!ticketActual.value && tieneAccesoVentanilla.value) {
            cargarEstadoVentanilla();
          }
        }, 10000);
      }

      requestAnimationFrame(() => {
        document.body.style.opacity = '1';
      });
    });

    // Watcher para detectar cambios en permisos
    watch(tieneAccesoVentanilla, (newValue) => {
      if (newValue) {
        // Si ahora tiene permisos, cargar estado
        cargarEstadoVentanilla();
        if (!refreshInterval) {
          refreshInterval = setInterval(() => {
            if (!ticketActual.value && tieneAccesoVentanilla.value) {
              cargarEstadoVentanilla();
            }
          }, 10000);
        }
      } else {
        // Si perdió permisos, limpiar datos
        ventanillaInfo.value = null;
        ticketActual.value = null;
        ticketsEspera.value = 0;
        if (timerInterval) {
          clearInterval(timerInterval);
          timerInterval = null;
        }
        if (refreshInterval) {
          clearInterval(refreshInterval);
          refreshInterval = null;
        }
      }
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkIfMobile);
      if (timerInterval) clearInterval(timerInterval);
      if (refreshInterval) clearInterval(refreshInterval);
    });

    return {
      userName,
      userLastName,
      unidad,
      userRoles,
      pageTitle,
      hasPermission,
      toggleSidebar,
      sidebarVisible,
      showUserDropdown,
      isMobile,
      toggleUserDropdown,
      logout,
      showPasswordModal,
      passwordForm,
      isChangingPassword,
      passwordError,
      openChangePasswordModal,
      closePasswordModal,
      changePassword,
      //Ventanilla,
      ventanillaInfo,
      ticketActual,
      ticketsEspera,
      ultimoLlamado,
      llamando,
      finalizando,
      tiempoAtencionFormateado,
      getEstadoTexto,
      cargarEstadoVentanilla,
      llamarSiguiente,
      finalizarAtencion,
      tieneAccesoVentanilla
    };
  }
};
</script>

<style scoped>
/* Colores basados en la imagen adjunta - Naranja y Gris Oscuro */
:root {
  --orange-primary: #FF6B35;
  --orange-dark: #D84315;
  --orange-darker: #BF360C;
  --orange-light: #FF8C42;
  --orange-lighter: #FFAB6B;
  --gray-dark: #2D3748;
  --gray-darker: #1A202C;
  --gray-light: #4A5568;
  --gray-lighter: #718096;
  --cream-light: #ece7e0;
  --cream-lighter: #FFFDFA;
  --text-dark: #2D2D2D;
  --text-darker: #1A1A1A;
  --text-light: #5A5A5A;
  --white: #FFFFFF;
}

/* Estilos base */
.custom-wrapper {
  display: flex;
  min-height: 100vh;
  position: relative;
  font-family: 'Roboto', sans-serif;
  overflow-x: hidden;
}

/* Sidebar principal */
.custom-sidebar {
  width: 260px;
  min-height: 100vh;
  background-color: #4A5568;
  transition: all 0.3s ease;
  position: relative;
  z-index: 100;
  flex-shrink: 0;
}

/* Sidebar en estado colapsado */
.custom-sidebar.collapsed {
  transform: translateX(-260px);
  position: absolute;
  left: -260px;
}

/* Sidebar en vista móvil */
.custom-sidebar.mobile-view {
  position: fixed;
  left: -260px;
  top: 0;
  height: 100vh;
  z-index: 1000;
  box-shadow: 3px 0 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, left 0.3s ease;
}
.custom-sidebar.mobile-view:not(.collapsed) {
  left: 0;
  transform: translateX(0);
}
.custom-sidebar.mobile-view.collapsed {
  left: -260px;
  transform: translateX(0);
}

/* Overlay para móviles */
.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
}

.mobile-sidebar-overlay.active {
  opacity: 1;
  visibility: visible;
}

/* Logo y elementos del sidebar */
.logo {
  padding: 10px 0;
  text-align: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.logo-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  text-decoration: none;
}

.logo-image {
  width: 100%;
  height: 90px;
  margin-bottom: 10px;
}

.logo-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-text {
  font-size: 18px;
  font-weight: 500;
  color: white;
}

/* Navegación del sidebar */
.sidebar-nav {
  padding: 20px 0;
  height: calc(100vh - 130px);
  overflow-y: auto;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-list li {
  margin: 5px 15px;
  border-radius: 4px;
  overflow: hidden;
}

.nav-list li.active {
  background-color: #FF6B35;
}

.nav-item {
  display: flex;
  align-items: center;
  height: 30px;
  padding: 8px 8px;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
}

.nav-item:hover {
  color: white;
  background-color: #D84315;
}

.nav-list li.active .nav-item {
  color: white;
  font-weight: 500;
}

.nav-item i {
  font-size: 20px;
  margin-right: 10px;
  width: 24px;
  text-align: center;
}

/* Panel principal */
.main-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: all 0.3s ease;
  width: 100%;
}

.main-panel.expanded {
  width: 100%;
}

/* Navbar superior */
.custom-navbar {
  height: 50px;
  background-color: #FF6B35;
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 99;
}

.navbar-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 0 20px;
}

/* Botón de toggle del sidebar */
.sidebar-toggle {
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 24px;
  width: 30px;
  padding: 0;
}

.toggle-bar {
  display: block;
  height: 2px;
  width: 100%;
  background-color: white;
  transition: all 0.3s ease;
}

/* Títulos */
.page-title {
  font-size: 1.25rem;
  font-weight: 500;
  color: white;
  width: 20%;
  text-align: center;
}

.page-title-mobile {
  color: white;
  display: none;
}

/* Menú de usuario */
.user-menu {
  position: relative;
}

.user-dropdown {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
}

.user-dropdown:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.user-dropdown i {
  margin-right: 8px;
  color: white;
  font-size: 1.2rem;
}

.user-info {
  display: flex;
  flex-direction: column;
  margin-left: 8px;
}

.user-name {
  font-weight: 500;
  color: white;
}

.user-roles {
  font-size: 0.75rem;
  opacity: 0.8;
  margin-top: 2px;
  color: white;
}

.dropdown-content {
  display: none;
  position: absolute;
  right: 0;
  background-color: white;
  min-width: 160px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 101;
  margin-top: 140px;
}

.dropdown-content.show {
  display: block;
}

.dropdown-content a {
  color: #333;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #FF6B35;
  color: white;
}

/* Contenido principal */
.content-wrapper {
  flex: 1;
  padding: 30px;
  background-color: #FFF8F0;
}

/* Footer */
.custom-footer {
  padding: 20px;
  background-color: #4A5568;
  color: white;
  text-align: center;
  font-size: 14px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

/* Estilos responsive */
@media (max-width: 768px) {
  .custom-sidebar {
    width: 260px;
    position: fixed;
    left: -260px;
    z-index: 1000;
  }

  .custom-sidebar.collapsed {
    left: 0;
  }

  .page-title {
    display: none;
  }

  .page-title-mobile {
    display: block;
    font-size: 1rem;
    font-weight: 500;
    margin-left: 10px;
  }

  .user-info {
    display: none;
  }

  .content-wrapper {
    padding: 15px;
  }
}

@media (max-width: 576px) {
  .content-wrapper {
    padding: 10px;
  }

  .custom-footer {
    padding: 10px;
    font-size: 0.8rem;
  }

  .nav-item span {
    font-size: 0.9rem;
  }

  .user-dropdown i {
    margin-right: 0;
  }
}

/* Transiciones y efectos */
.nc-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Scrollbar personalizado para el sidebar */
.sidebar-nav::-webkit-scrollbar {
  width: 5px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Estilos para el modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #eee;
}

.modal-header h3 {
  margin: 0;
  color: #2D2D2D;
}

.modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.form-control:focus {
  outline: none;
  border-color: #FF6B35;
}

.error-message {
  color: #dc3545;
  font-size: 14px;
  margin-bottom: 15px;
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-primary {
  background-color: #FF6B35;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background-color: #D84315;
}

.btn-primary:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.btn-secondary {
  background-color: #4A5568;
  color: white;
}

.btn-secondary:hover {
  background-color: #2D3748;
}

/* Responsive */
@media (max-width: 768px) {
  .modal-content {
    width: 95%;
    margin: 20px;
  }

  .modal-actions {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

/* ===== CONTROLES DE VENTANILLA ===== */
.ventanilla-controls {
  display: flex;
  align-items: center;
  gap: 15px;
  background: linear-gradient(135deg, #0f1119 0%, #1a1d2e 100%);
  padding: 6px 15px;
  margin: 0px 20px;
  border-radius: 10px;
  flex: 1;
  justify-content: right;
}

.ventanilla-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ventanilla-badge {
  color: white;
  font-size: 14px;
}

.ventanilla-badge strong {
  color: #FFD700;
}

.ventanilla-estado {
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.1);
}

.ventanilla-estado.disponible {
  color: #2ecc71;
}
.ventanilla-estado.ocupada {
  color: #e74c3c;
}
.ventanilla-estado.pausa {
  color: #f39c12;
}

.ventanilla-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Atención activa en dashboard */
.atencion-activa {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(46, 204, 113, 0.2);
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid rgba(46, 204, 113, 0.3);
}

.ticket-actual-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.ticket-actual-numero {
  color: #FFD700;
  font-weight: bold;
  font-family: monospace;
  font-size: 16px;
}

.tiempo-atencion-dash {
  color: #2ecc71;
  font-family: monospace;
  font-size: 14px;
  font-weight: bold;
}

/* Botón Llamar Siguiente */
.btn-llamar-dash {
  background: #FFD700;
  color: #1A202C;
  border: none;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
}

.btn-llamar-dash:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(255, 215, 0, 0.4);
}

.btn-llamar-dash:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-icon-dash {
  font-size: 16px;
}

.btn-count-dash {
  background: #e74c3c;
  color: white;
  padding: 0px 8px;
  border-radius: 12px;
  font-size: 11px;
  margin-left: 2px;
}

/* Botón Finalizar */
.btn-finalizar-dash {
  background: #2ecc71;
  color: white;
  border: none;
  padding: 6px 14px;
  border-radius: 8px;
  font-weight: bold;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-finalizar-dash:hover:not(:disabled) {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(46, 204, 113, 0.4);
}

.btn-finalizar-dash:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Responsive */
@media (max-width: 992px) {
  .ventanilla-controls {
    flex-direction: column;
    padding: 6px 10px;
    gap: 6px;
  }

  .ventanilla-info {
    font-size: 12px;
  }

  .ventanilla-actions {
    width: 100%;
    justify-content: center;
  }

  .atencion-activa {
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .ventanilla-controls {
    display: none;
  }
}

@media (max-width: 576px) {
  .ventanilla-controls {
    display: none;
  }
}
</style>
